import { useEffect, useState } from 'react';
import { PWA_UI_MEDIA_QUERIES, shouldShowPwaMobileUi } from '../utils/pwaUtils';

function watchPwaUiMediaQueries(onChange) {
  const queries = [
    window.matchMedia(PWA_UI_MEDIA_QUERIES.mobileViewport),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.desktopViewport),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.standalone),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.browser),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.finePointer),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.hoverCapable),
  ];

  queries.forEach((query) => query.addEventListener('change', onChange));

  return () => {
    queries.forEach((query) => query.removeEventListener('change', onChange));
  };
}

/** Re-renders when viewport or standalone display mode changes. */
export function usePwaMobileUi() {
  const [showPwaUi, setShowPwaUi] = useState(() => shouldShowPwaMobileUi());

  useEffect(() => {
    const sync = () => setShowPwaUi(shouldShowPwaMobileUi());

    sync();
    window.addEventListener('resize', sync);
    const unwatchMedia = watchPwaUiMediaQueries(sync);

    return () => {
      window.removeEventListener('resize', sync);
      unwatchMedia();
    };
  }, []);

  return showPwaUi;
}
